export default "__VITE_ASSET__wGvqj0$t__"